import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  useTheme,
} from '@mui/material';

const MultiChipSelect = ({
  items = [],
  value = [],
  onChange,
  onClose,
  label = '선택',
  onClick,
  onFocus,
  disabled = false,
  labelYn = true,
}) => {
  const theme = useTheme();

  const getStyles = (name, selected, theme) => ({
    display: 'flex',
    alignItems: 'center',
    fontWeight:
      selected.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  });

  return (
    <FormControl fullWidth>
      {labelYn && <InputLabel id="multi-chip-label">{label}</InputLabel>}
      <Select
        labelId="multi-chip-label"
        multiple
        value={value}
        onChange={onChange}
        onClose={onClose}
        onClick={onClick}
        onFocus={onFocus}
        disabled={disabled}
        displayEmpty
        input={
          <OutlinedInput
            label=""
            notched={false}
            sx={{
              paddingTop: '8px !important',
              paddingBottom: '8px !important',
            }}
          />
        }
      >
        {items.map((item) => (
          <MenuItem
            key={item.value}
            value={item.value}
            style={getStyles(item.value, value, theme)}
          >
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultiChipSelect;
